export {SlidingText} from './SlidingText';
